export default __webpack_public_path__ + "static/media/ad-product.5c6b1213.svg";